import TagManager from "react-gtm-module";
import { DEPLOY_ENV } from "../app/environment";

const MEASUREMENT_ID = {
  dev: "G-4BH4SYZ8HK",
  stg: "G-W211Z025SH",
  partner: "G-LC92YMME50",
  prod: "G-BYYV0RQ089",
};

/*function addScriptToWindow(scriptSrc: string) {
  try {
    const container = document.head || document.documentElement,
      script = document.createElement("script");
    script.setAttribute("async", "");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", scriptSrc);
    container.insertBefore(script, container.children[0]);
  } catch (e) {
    console.error("Failed to inject script", e);
  }
}
declare global {
  interface Window {
    dataLayer: any[][];
  }
}
window.dataLayer = window.dataLayer || [];
function gtag(...args: any[]) {
  window.dataLayer.push(args);
}

if (DEPLOY_ENV !== "local") {
  addScriptToWindow(
    `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID[DEPLOY_ENV]}`
  );
  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID[DEPLOY_ENV]);
}*/

if (DEPLOY_ENV !== "local") {
  const tagManagerArgs = {
    gtmId: MEASUREMENT_ID[DEPLOY_ENV],
    dataLayer: {
      js: new Date(),
    },
  };
  TagManager.initialize(tagManagerArgs);
}
